import { TwoFactorAuthorizationStatus } from "Services/Api/Users/Types";
import ChangePassword from "./ChangePassword";
import GeneralInfo from "./GeneralInfo";
import MFASettings from "./MFASettings";
import Roles from "./Roles";
import ModuleSettings from "./ModuleSetting";

type Props = {
    isProfile: boolean,
    isAddNewUser: boolean,
    isUserRole: boolean,
    openModal: (val: "changePassword" | "save" | "enableMFA") => void,
    twoFactorAuthenticationStatus: TwoFactorAuthorizationStatus
}

const AccountSettings = ({ isProfile, isAddNewUser, isUserRole, openModal, twoFactorAuthenticationStatus } : Props) => {

    return <>
        <GeneralInfo {...{ isProfile, isAddNewUser }} openModal={() => openModal("save")} />
        <Roles {...{ isProfile }} />
        {!isAddNewUser && <MFASettings {...{ isProfile, twoFactorAuthenticationStatus }} openModal={() => openModal("enableMFA")} />}
        {isProfile ? <ChangePassword {...{ isUserRole }} openModal={() => openModal("changePassword")} /> : <ModuleSettings  {...{ isProfile }} />}
    </>
}

export default AccountSettings;